export default {
    UPDATE_USER_TOKEN : 'UPDATE_USER_TOKEN',
    REUPDATE_USER_TOKEN : 'REUPDATE_USER_TOKEN'
}

